import styled from 'styled-components';

type PlaySimpleProps = {
  backgroundImage: any;
  productsHeight: any;
};

export const StyledPlaySimpleSpecialOffer = styled.div<PlaySimpleProps>`
  width: 100%;
  max-width: 400px;
  min-width: 343px;
  height: 200px;
  border-radius: 12px;
  box-sizing: border-box;
  position: relative;
  font-family: var(--font-family), Arial;
  background-color: #ffffff;
  background-image: ${({ backgroundImage }) =>
    backgroundImage ? `url("${backgroundImage}")` : 'none'};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left bottom;
  padding: 8px 8px 0 8px;
  margin-bottom: 18px;

  .container {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;

    .availability {
      color: #514b3d;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-top: 8px;
      text-align: center;
    }

    .products {
      display: flex;
      margin-top: ${({ productsHeight }: any) =>
        productsHeight ? '8px' : ' 6px'};
      width: 155px;

      &--main-image {
        width: 166px;
        height: 166px;
        position: absolute;
        right: 0;
        top: 8px;
        margin-right: 8px;

        .image {
          width: 100%;
          object-fit: contain;
          height: auto;
        }
      }

      &-items {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: ${({ productsHeight }: any) =>
          productsHeight ? '120px' : '102px'};

        &--sub {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin-top: 8px;
          column-gap: 4px;
          row-gap: 8px;

          &__ios13 {
            gap: unset;
            margin-right: -4px;
            margin-bottom: -8px;
          }
        }
      }
    }

    .price {
      margin-bottom: 20px;
      margin-right: 8px;
      width: 160px;
      height: 38px;
      border-radius: 30px;
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      right: 0;
      box-shadow: inset 0 -4px 0 0 rgba(20, 128, 29, 1);

      .totalPrice {
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }
    .timer {
      margin-bottom: 20px;
      width: 160px;
      height: 38px;
      position: absolute;
      bottom: 15px;
      right: -20px;
      color: #514B3D;
      font-size: 12px;
      font-weight: 400;
    }
  }
`;
